import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { ArrowRight, Check } from 'react-feather';
import useTranslation from 'next-translate/useTranslation';
import { mobile, useIsDesktop } from '../../style/constants';
import { TextRegular16, TitleBold21 } from '../../VuexyDesign/atoms/Text';
import { TextBold14 } from '../common/Text';
import { useCheckUserProPlanMember } from '../../api';
import { ProOutlineButton } from '../../VuexyDesign/atoms/_index';

export const ReleaseYourMusicBanner = ({
  isMobileView = false,
}: {
  isMobileView?: boolean;
}) => {
  const { t } = useTranslation('distributionLanding');
  const isDesktop = useIsDesktop();
  const isProMember = useCheckUserProPlanMember();

  const isMobileviewBanner = () => (
    <>
      <ReleaseYourMusicBannerContainerWrapper>
        <Banner isMobileView className="w-100">
          <div className="d-flex flex-column align-items-center">
            <img
              src="/static/images/streamingPlatforms.webp"
              alt="Streaming Platforms"
              width={150}
              height={90}
            />
            <div className="mt-1 d-flex align-items-center mb-1">
              <TitleBold21 style={{ marginBottom: '0rem' }} className="mr-1">
                {t('upload:releaseATrack') as string}
              </TitleBold21>
              <img
                src="/static/images/pro-logo.svg"
                alt="Pro Logo"
                width={40}
                height={19}
              />
            </div>
            <div className="d-flex align-items-center ">
              <Check size={14} color="#e51b61" style={{ marginRight: '3px' }} />
              <GradientText className="mr-1">
                {t('upload:keepYourRights') as string}
              </GradientText>
              <Check size={14} color="#e51b61" style={{ marginRight: '3px' }} />
              <GradientText>{t('upload:earnMoney') as string}</GradientText>
            </div>
            <TextRegular16 className="mt-1 text-center">
              {t('upload:showcaseYourTalent') as string}
            </TextRegular16>
            <div className="my-1">
              <Link
                href={`${
                  isProMember ? '/distribution/welcome' : '/become-pro'
                }`}
              >
                <ReleaseButton>
                  <>
                    {t('upload:releaseNow') as string}
                    <GradientArrow size={14} />
                  </>
                </ReleaseButton>
              </Link>
            </div>
            <div>
              <Link href="/music-distribution">
                <SpanDesignTextWithUnderline className="mx-1">
                  {t('myTracks:whatIsMusicRelease') as string}
                </SpanDesignTextWithUnderline>
              </Link>
            </div>
          </div>
        </Banner>
      </ReleaseYourMusicBannerContainerWrapper>
    </>
  );

  if (isMobileView) {
    return isMobileviewBanner();
  }
  return (
    <>
      {isDesktop ? (
        <ReleaseYourMusicBannerContainerWrapper>
          <Banner className="w-100">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex flex-column ">
                <div className="mt-1 d-flex align-items-center mb-1">
                  <TitleBold21
                    style={{ marginBottom: '0rem' }}
                    className="mr-1"
                  >
                    {t('upload:releaseATrack') as string}
                  </TitleBold21>
                  <img
                    src="/static/images/pro-logo.svg"
                    alt="Pro Logo"
                    width={40}
                    height={19}
                  />
                </div>
                <div className="d-flex align-items-center ">
                  <Check
                    size={14}
                    color="#e51b61"
                    style={{ marginRight: '3px' }}
                  />
                  <GradientText className="mr-1">
                    {t('upload:keepYourRights') as string}
                  </GradientText>
                  <Check
                    size={14}
                    color="#e51b61"
                    style={{ marginRight: '3px' }}
                  />
                  <GradientText>{t('upload:earnMoney') as string}</GradientText>
                </div>
                <TextRegular16 className="mt-1">
                  {t('upload:showcaseYourTalent') as string}
                </TextRegular16>
              </div>
              <div
                className="d-flex align-items-center"
                style={{ gap: '1rem' }}
              >
                <div>
                  <img
                    src="/static/images/streamingPlatforms.webp"
                    alt="Streaming Platforms"
                    width={150}
                    height={90}
                  />
                </div>
                <div>
                  <Link href="/music-distribution">
                    <SpanDesignTextWithUnderline className="mx-1">
                      {t('myTracks:whatIsMusicRelease') as string}
                    </SpanDesignTextWithUnderline>
                  </Link>
                </div>
                <div>
                  <Link
                    href={`${
                      isProMember ? '/distribution/welcome' : '/become-pro'
                    }`}
                  >
                    <ReleaseButton>
                      <>
                        {t('upload:releaseNow') as string}
                        <GradientArrow size={14} />
                      </>
                    </ReleaseButton>
                  </Link>
                </div>
              </div>
            </div>
          </Banner>
        </ReleaseYourMusicBannerContainerWrapper>
      ) : (
        <>{isMobileviewBanner()}</>
      )}
    </>
  );
};

const Banner = styled.div<{ isMobileView?: boolean }>`
  padding: ${(props) => (props.isMobileView ? '1rem' : '2rem')};
  border: 2px solid transparent;
  border-radius: 6px;
  background: linear-gradient(135deg, #fcf3f8 0%, #f5f8fe 100%),
    linear-gradient(to left, #743ad5, #d53a9d);
  background-clip: padding-box, border-box;
  background-origin: padding-box, border-box;

  @media ${mobile} {
    padding: 2rem 0.7rem;
  }
`;
const GradientText = styled(TextBold14)`
  background: linear-gradient(315.97deg, #1159f1 1.64%, #f41657 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const GradientArrow = styled(ArrowRight)`
  color: #5246c5;
`;
const ReleaseButton = styled(ProOutlineButton)`
  &:hover {
    ${GradientArrow} {
      color: white;
    }
  }
`;

const SpanDesignTextWithUnderline = styled.span`
  font-weight: 400;
  font-size: 13px;
  text-decoration-line: underline;
  cursor: pointer;
`;

const ReleaseYourMusicBannerContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: auto;
  padding: auto;
  width: 100%;
`;
